<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link :to="{ path: '/message-template' }" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>{{ viewService.subject }}</td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editMessageTemplate(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deletemessagesPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Id") }}</b>
                    </td>
                    <td>{{ viewService.id }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.TemplateDescription") }}</b>
                    </td>
                    <td>{{ viewService.templateDescription }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Subject") }}</b>
                    </td>
                    <td>{{ viewService.subject }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.MessageType") }}</b>
                    </td>
                    <td>{{ viewService.messageType }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{
                        `${$t("customers.label.category")} ${$t(
                          "customers.label.id"
                        )}`
                      }}</b>
                    </td>
                    <td>{{ viewService.evrCategory }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("customers.label.event_id") }}</b>
                    </td>
                    <td>{{ viewService.evrEvent }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Header") }}</b>
                    </td>
                    <td>{{ viewService.header }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Body") }}</b>
                    </td>
                    <td>{{ viewService.body }}</td>
                  </tr>
                  <tr>
                    <td class="border-none">
                      <b>{{ $t("setup.label.Footer") }} </b>
                    </td>
                    <td class="border-none">
                      {{ viewService.footer }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deletemessagesPopup"
      :title="$t('setup.label.DeleteMessage')"
      @deletePressed="deletemessages()"
      @cancelPressed="deletemessagesPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      id: "",
      viewService: {},
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deletemessagesPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      Services: (state) => state.messageTemplate.ListViewMessages,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    breadcrumbs() {
      return [
        {
          name: this.$t("admin.label.Message Template"),
          to: "/message-template/",
        },
        { name: this.viewService.subject, to: "/" },
      ];
    },
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editMessageTemplate(id) {
      this.$router.push({ name: "Edit Message Template", params: { id: id } });
    },
    async deletemessages() {
      this.deletemessagesPopup = false;
      await this.$store.dispatch(
        "messageTemplate/deletemessagesAction",
        this.id
      );
      await this.$swal({
        title: "Success",
        icon: "success",
        text: "Manage Message Successfully Deleted!!",
        type: "success",
      });
      this.$router.push(`/message-template`);
    },

    async getViewMessages() {
      try {
        await this.$store.dispatch("messageTemplate/setViewMessages", this.id);
        this.viewService = this.Services;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getViewMessages();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
